import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ModeOfTravelIcon(props: IconProps) {
    return <Icon {...props} iconKey={"mode_of_travel"}/>
}
